export const imgUrl = 'https://donerightaway.com/jiff-done-backend/public/'

// Get full image URL (no filename modification)
export const getImageUrl = (path) => {
  if (!path) return '';
  return `${imgUrl}${path}`;
}